(function() {
  var DialogController, Treatment,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass("core::Angular/DialogController");

  Treatment = App.loadClass("portal::Angular/Ratings/Models/Treatment");

  exports.TreatmentDialogController = (function(superClass) {
    extend(TreatmentDialogController, superClass);

    function TreatmentDialogController(scope, transitions, repo, modalInstance, lineups_id, treatment) {
      var t;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      TreatmentDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      t = new Treatment();
      if (treatment != null) {
        this.scope.treatment = $.extend(t, treatment);
        this.scope.title = 'Edit Treatment';
      } else {
        this.scope.treatment = t;
        this.scope.title = 'Add Treatment';
      }
      this.scope.absolute_errors = false;
      this.lineups_id = lineups_id;
    }

    TreatmentDialogController.prototype.save = function() {
      var promise;
      promise = this.repo.saveTreatment(this.lineups_id, this.scope.treatment).then((function(_this) {
        return function(response) {
          var ref;
          if ((ref = response.status) != null ? ref.type : void 0) {
            return _this.closeWithAlert(response.status, response.data, false);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.closeWithAlert({
            type: 'error',
            msg: 'Failed to save treatment'
          });
        };
      })(this));
      return promise;
    };

    return TreatmentDialogController;

  })(DialogController);

}).call(this);
